import { supabase } from '../lib/supabase';

export const homepageSliderService = {
	// Get all active slides ordered by display_order
	async getSlides() {
		try {
			const { data, error } = await supabase
				.from('homepage_slides')
				.select('*')
				.eq('is_active', true)
				.order('display_order', { ascending: true });

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching homepage slides:', error);
			return { data: null, error };
		}
	},

	// Get a specific slide by ID
	async getSlideById(id) {
		try {
			const { data, error } = await supabase
				.from('homepage_slides')
				.select('*')
				.eq('id', id)
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching slide:', error);
			return { data: null, error };
		}
	},

	// Create a new slide
	async createSlide(slideData) {
		try {
			const { data, error } = await supabase
				.from('homepage_slides')
				.insert([slideData])
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error creating slide:', error);
			return { data: null, error };
		}
	},

	// Update a slide
	async updateSlide(id, updates) {
		try {
			const { data, error } = await supabase
				.from('homepage_slides')
				.update(updates)
				.eq('id', id)
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error updating slide:', error);
			return { data: null, error };
		}
	},

	// Delete a slide
	async deleteSlide(id) {
		try {
			const { error } = await supabase
				.from('homepage_slides')
				.delete()
				.eq('id', id);

			if (error) throw error;
			return { error: null };
		} catch (error) {
			console.error('Error deleting slide:', error);
			return { error };
		}
	}
};
